export const isVideoReady = (video: HTMLVideoElement | null) =>
  Boolean(video && video.readyState >= 2 && video.videoWidth && video.videoHeight);

export const clearVideo = (video: HTMLVideoElement) => {
  video.pause();
  video.srcObject = null;
  video.removeAttribute('src');
  video.load();
};
